export const onModelInputChange = (
  e: string,
  onChange: (newValue: string) => void,
  model: any,
  propName: string
) => {
  if (onChange) {
    if (model && model[propName] !== e) {
      const result = { ...model };
      result[propName] = e;
      onChange(result);
    }
  }
};

export default {
  onModelInputChange
};
